export const Info = {
    company: '㈜다하우스',
    ceo: 'Da Jeung Kim',
    num: '275-86-01965',
    address: '05839 서울특별시 송파구 충민로 52 (문정동) B-719,720',
    csEmail: 'cs@javindeseoul.com',
    helpEmail: 'help@javindeseoul.com',

    csNum: '1899-2043',
    hours: 'MON - FRI 11:00am - 4:00pm (Lunch 12:00pm - 1:30pm) SAT.SUN.Holiday OFF',
    an: '기업 986-024364-04-025 예금주: ㈜다하우스'
}

export const MainSlideData = [
    {
        name: 'NEW Wink Eye Shade Primer',
        desc: '표정의 깊이를 더해주는 톤온톤 음영 메이크업 전용',
        subDesc: '아이 섀도우 프라이머',
        link: '/EYE/eyeshadow',
    },
    {
        name: 'NEW Wink Eye Shade Primer',
        desc: '섬세한 쉐이드와 크리즈-프리 프라이머가 만나',
        subDesc: '첫 발색 그대로 유지',
        link: '/EYE/eyeshadow',
    },
]

export const MainBannerData = {
    tit: '유연한 팁으로 얇고 정교한 핏팅',
    desc: 'NEW SHADES 윙크 리퀴드 컨실러',
    link: '/FACE'
}